import Quill from 'quill'
import { htmlEditButton } from 'quill-html-edit-button'
import TableUp from 'quill-table-up'
import ContinuousListModule, {
    CONTINUOUS_LIST_MODULE_NAME,
    CONTINUOUS_LIST_ICON,
} from '@/Support/Editor/ContinuousListModule'

Quill.register({ 'modules/htmlEditButton': htmlEditButton })
Quill.register({ [`modules/${TableUp.moduleName}`]: TableUp }, true)
Quill.register({ [`modules/${CONTINUOUS_LIST_MODULE_NAME}`]: ContinuousListModule }, true)

// Register the toolbar icon so Quill knows how to render the button
const icons = Quill.import('ui/icons') as Record<string, string>
icons['continuous-list'] = CONTINUOUS_LIST_ICON
